import $ from "jquery";
const baseUrl = "api:///v4/runtime-persons";
const get = (data) => $.ajax({
    method: "GET",
    url: baseUrl,
    data,
});
const getPerson = (personId) => $.ajax({
    method: "GET",
    url: `${baseUrl}/${personId}`,
});
const getData = (personId) => $.ajax({
    method: "GET",
    url: `${baseUrl}/${personId}/data`,
});
const getRequestContexts = (personId) => $.ajax({
    method: "GET",
    url: `${baseUrl}/${personId}/request-contexts`,
});
const getShareables = (personId) => $.ajax({
    method: "GET",
    url: `${baseUrl}/${personId}/shareables`,
});
const getAudienceMemberships = (personId) => $.ajax({
    method: "GET",
    url: `${baseUrl}/${personId}/audience-memberships`,
});
const getRelationships = (personId, data) => $.ajax({
    method: "GET",
    url: `${baseUrl}/${personId}/relationships`,
    data,
});
const getJourneys = (personId) => $.ajax({
    method: "GET",
    url: `${baseUrl}/${personId}/journeys`,
});
const getSteps = (personId, data) => $.ajax({
    method: "GET",
    url: `${baseUrl}/${personId}/steps`,
    data,
});
const getShares = (personId) => $.ajax({
    method: "GET",
    url: `${baseUrl}/${personId}/shares`,
});
const update = (personId, data) => $.ajax({
    method: "PUT",
    url: `${baseUrl}/${personId}`,
    contentType: "application/json",
    data: JSON.stringify(data),
});
const create = (data) => $.ajax({
    method: "POST",
    url: baseUrl,
    contentType: "application/json",
    data: JSON.stringify(data),
});
export default {
    get,
    getPerson,
    getData,
    getRequestContexts,
    getShareables,
    getAudienceMemberships,
    getRelationships,
    getJourneys,
    getSteps,
    getShares,
    create,
    update,
};
